module.exports = __webpack_public_path__ + "assets/img/barracuda.91b3b909.png";